import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Route, Routes, Link } from "react-router-dom";
import { Layout, Menu, Space, Button, Row, Dropdown } from "antd";
import {
  DashboardOutlined,
  UserOutlined,
  SettingOutlined,
  TeamOutlined,
  LogoutOutlined,
  SplitCellsOutlined,
  ShopOutlined,
  AuditOutlined,
} from "@ant-design/icons";

import DashboardPage from "./pages/DashboardPage";
import AttendancePage from "./pages/AttendancePage";
import SettingPage from "./pages/SettingPage";
import Employee from "./pages/Employee";
import Login from "./pages/Login";
import { useDispatch } from "react-redux";
import { logout } from "./slices/auth";
import DetailEmployee from "./pages/DetailEmployee";
import Branch from "./pages/branchs/Branch";
import DownloadLocalApk from "./pages/DownloadLocalApk";
import ErrorUpload from "./pages/ErrorUpload";
import DetailAttendance from "./pages/DetailAttendance";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import LeaveList from "./pages/leaves/ListLeave";
import HistoryLeave from "./pages/leaves/HistoryLeave";
import ApprovalPage from "./pages/approvals/ApprovalPage";
import Support from "./pages/Support";

const { Header, Content, Footer } = Layout;

const App: React.FC = () => {
  const dispatch = useDispatch();
  const handleLogout = () => {
    // Tambahkan logika logout di sini, seperti membersihkan token atau redirect ke halaman login
    console.log("Logout berhasil");
    dispatch(logout());
  };

  // const menuItems = [
  //   { key: "/", label: "Dashboard", icon: <DashboardOutlined />, link: "/" },
  //   { key: "/employee", label: "Employee", icon: <TeamOutlined />, link: "/employee" },
  //   { key: "/attendance", label: "Attendance", icon: <UserOutlined />, link: "/attendance" },
  //   { key: "/branch", label: "Branch", icon: <UserOutlined />, link: "/branch" },
  //   { key: "/settings", label: "Settings", icon: <SettingOutlined />, link: "/settings" },
  // ];

  // const [visibleMenu, setVisibleMenu] = useState<string[]>([]);
  // const [overflowMenu, setOverflowMenu] = useState<string[]>([]);

  // Handle responsive logic
  // useEffect(() => {
  //   const handleResize = () => {
  //     const isSmallScreen = window.innerWidth < 768; // Adjust breakpoint as needed
  //     if (isSmallScreen) {
  //       setVisibleMenu(menuItems.slice(0, 2).map((item) => item.key)); // Show first 2 menus
  //       setOverflowMenu(menuItems.slice(2).map((item) => item.key)); // Rest in dropdown
  //     } else {
  //       setVisibleMenu(menuItems.map((item) => item.key)); // Show all menus
  //       setOverflowMenu([]); // No overflow
  //     }
  //   };

  //   handleResize(); // Initial setup
  //   window.addEventListener("resize", handleResize); // Add listener
  //   return () => window.removeEventListener("resize", handleResize); // Cleanup
  // }, [menuItems]);

  // const dropdownMenu = (
  //   <Menu>
  //     {menuItems
  //       .filter((item) => overflowMenu.includes(item.key))
  //       .map((item) => (
  //         <Menu.Item key={item.key} icon={item.icon}>
  //           <Link to={item.link}>{item.label}</Link>
  //         </Menu.Item>
  //       ))}
  //   </Menu>
  // );

  return (
    <Router>
      <Layout>
        {/* <Header>
      <Row justify="space-between" align="middle">
        
        <Space>
          <div
            className="logo"
            title="LOGO"
            style={{ color: "white", fontWeight: "bold", fontSize: 20 }}
          >
            DB HRIS
          </div>

          
          <Menu theme="dark" mode="horizontal" selectedKeys={['/dashboard']}>
            {menuItems
              .filter((item) => visibleMenu.includes(item.key))
              .map((item) => (
                <Menu.Item key={item.key} icon={item.icon}>
                  <Link to={item.link}>{item.label}</Link>
                </Menu.Item>
              ))}
          </Menu>

          
          {overflowMenu.length > 0 && (
            <Dropdown overlay={dropdownMenu} trigger={["click"]}>
              <Button icon={<EllipsisOutlined />} />
            </Dropdown>
          )}
        </Space>

        
        <Button type="primary" icon={<LogoutOutlined />} onClick={handleLogout}>
          Logout
        </Button>
      </Row>
    </Header> */}
        <Header>
          <Row justify="space-between" align="middle">
            <Space>
              <div
                className="logo"
                title="LOGO"
                style={{ color: "white", fontWeight: "bold", fontSize: 20 }}
              >
                DATT
              </div>

              <Menu
                theme="dark"
                mode="horizontal"
                defaultSelectedKeys={["/dashboard"]}
              >
                <Menu.Item key="/" icon={<DashboardOutlined />}>
                  <Link to="/">Dashboard</Link>
                </Menu.Item>
                <Menu.Item key="/employee" icon={<TeamOutlined />}>
                  <Link to="/employee">Employee</Link>
                </Menu.Item>
                <Menu.Item key="/attendance" icon={<UserOutlined />}>
                  <Link to="/attendance">Attendance</Link>
                </Menu.Item>
                <Menu.Item key="/branch" icon={<ShopOutlined />}>
                  <Link to="/branch">Branch</Link>
                </Menu.Item>
                <Menu.Item key="/leaves" icon={<SplitCellsOutlined />}>
                  <Link to="/leaves">Leave</Link>
                </Menu.Item>
                <Menu.Item key="/approval" icon={<AuditOutlined />}>
                  <Link to="/approval">Approval</Link>
                </Menu.Item>
                <Menu.Item key="/settings" icon={<SettingOutlined />}>
                  <Link to="/settings">Settings</Link>
                </Menu.Item>
              </Menu>
            </Space>

            <Button
              type="primary"
              icon={<LogoutOutlined />}
              onClick={() => handleLogout()}
            >
              Logout
            </Button>
          </Row>
        </Header>
        <Content style={{ padding: "0 50px", marginTop: "40px" }}>
          <div
            className="site-layout-content"
            style={{ padding: 24, minHeight: 380 }}
          >
            <Routes>
              <Route path="/" element={<DashboardPage />} />
              <Route path="/attendance" element={<AttendancePage />} />
              <Route
                path="/attendance-detail/:id"
                element={<DetailAttendance />}
              />
              <Route path="/settings" element={<SettingPage />} />
              <Route path="/approval" element={<ApprovalPage />} />
              <Route path="/employee" element={<Employee />} />
              <Route path="/branch" element={<Branch />} />
              <Route path="/leaves" element={<LeaveList />} />
              <Route path="/leave/:eid" element={<HistoryLeave />} />
              <Route path="/employee/:eid" element={<DetailEmployee />} />
              <Route path="/login" element={<Login />} />
              <Route path="/downloads" element={<DownloadLocalApk />} />
              <Route path="/error-upload" element={<ErrorUpload />} />
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />
              <Route path="/support" element={<Support />} />
            </Routes>
          </div>
        </Content>
        <Footer style={{ textAlign: "center" }}>
          Daily Company HRIS ©2024 Created by IT Development
        </Footer>
      </Layout>
    </Router>
  );
};

export default App;
